import { useMutation } from '@tanstack/react-query'
import { getCustomerDocumentLink } from 'services/CustomerDocumentsService'

export const useCreateCustomerDocumentLink = () => {
  return useMutation({
    mutationFn: getCustomerDocumentLink,
  })
}
